// client/src/components/Footer.jsx - Pied de page
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-white py-8" style={{ backgroundColor: '#2C3E50' }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-6 md:mb-0 md:w-1/3">
            <div className="flex flex-col items-center md:items-start space-y-2">
              <img src="/img/logo_white-min.png" alt="YAQAM" className="h-20 w-auto object-contain" />
              <Link to="/" className="text-xl font-bold text-white">Y A Quoi A Manger</Link>
            </div>
            <p className="mt-4 text-white text-center md:text-left">
              Finis le stress de la planification des repas !
              YAQAM génère des idées de repas intelligentes et ultra-personnalisées.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:w-2/3">
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Navigation</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-white hover:opacity-80 transition-all">
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard" className="text-white hover:opacity-80 transition-all">
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/idees-de-repas" className="text-white hover:opacity-80 transition-all">
                    Idées de recettes
                  </Link>
                </li>
                <li>
                  <Link to="/subscription" className="text-white hover:opacity-80 transition-all">
                    Abonnement
                  </Link>
                </li>
                <li>
                  {/* <Link to="/blog" className="text-white hover:opacity-80 transition-all">
                    Blog
                  </Link> */}
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Support</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/confidentialite" className="text-white hover:opacity-80 transition-all">
                    Politique de confidentialité
                  </a>
                </li>
                <li>
                  <Link to="/contact" className="text-white hover:opacity-80 transition-all" aria-label="Contact">
                    Contact
                  </Link>
                </li>
                <li>
                  <a href="/faq" className="text-white hover:opacity-80 transition-all">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Légal</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/cgu" className="text-white hover:opacity-80 transition-all">
                    Conditions Générales d'Utilisation
                  </a>
                </li>
                <li>
                  <a href="/cgv" className="text-white hover:opacity-80 transition-all">
                    Conditions Générales de Vente
                  </a>
                </li>
                <li>
                  <a href="/mentions-legales" className="text-white hover:opacity-80 transition-all">
                    Mentions légales
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t text-center text-white" style={{ borderColor: '#34495e' }}>
          <p>© 2025 Y Quoi A Manger. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
